import React, { useEffect, useState } from 'react';
import Gallery from 'react-photo-gallery';
import InfiniteScroller from 'react-infinite-scroller';
import DesignItem from './DesignItem';
import { useSelector, useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DesignList.css';

const DesignList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(state => state.authentication.user);
  const userId = user.role === 'client' ? user.userId : null;
  const loading = useSelector(state => state.design.loading);
  const designs = useSelector(state => state.design.designs);
  const hasMoreDesign = useSelector(state => state.design.hasMoreDesign);
  const [designList, setDesignList] = useState([]);

  useEffect(() => {
    const temp = [];
    designs.forEach((design, index) => {
      const previewVersion = design.updatedAt ? new Date(design.updatedAt).getTime() : Date.now();
      temp.push({
        src: `${process.env.REACT_APP_FILE_SERVER}/resources/designs/${design._id}/thumbnail_large.png?v=${previewVersion}`,
        width: design.size.width,
        height: design.size.height,
        key: index.toString(),
        type: 'Design',
        data: {
          id: design._id,
          name: design.name,
          index,
          pagesCount: design.pagesCount,
          previewVersion,
        },
      });
    });
    setDesignList(temp);
    const mainElement = document.getElementsByClassName('main')[0];
    if (mainElement.clientHeight === mainElement.scrollHeight && hasMoreDesign && !loading) {
      dispatch(designActions.search(userId, {}, false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [designs]);

  const customInfiniteScroller = (initialLoad, hasMore, type, photos , showNotFound = true) => {
    return (
      <InfiniteScroller
        pageStart={0}
        threshold={100}
        initialLoad={false}
        hasMore={hasMore}
        loadMore={() => {
          !loading && dispatch(designActions.search(userId, {}, false));
        }}
        useWindow={false}
        getScrollParent={() => document.getElementsByClassName('main')[0]}
      >
        {(photos.length == 0 && showNotFound) && <span>{t('itemNotFound')}</span>}
        <Gallery photos={photos} targetRowHeight={200} renderImage={customRenderImage} />
      </InfiniteScroller>
    );
  };

  // eslint-disable-next-line react/prop-types, no-unused-vars
  const customRenderImage = ({ index, left, top, key, photo }) => {
    const imgStyle = {
      transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s',
    };
    const cont = {
      marginTop: '-2px',
      cursor: 'pointer',
      overflow: 'hidden',
      position: 'relative',
    };
    return (
      <DesignItem
        key={key}
        index={index}
        photo={photo}
        imgStyle={imgStyle}
        cont={cont}
        onClick={handleDesignClicked}
      />
    );
  };

  const handleDesignClicked = designId => {
    history.push(`/edit/design/${designId}`);
  };

  return (
    <div className="designList">
      <header>
        <h2>{t('allYourDesigns')}</h2>
      </header>
      <div className="content">
        {customInfiniteScroller(true, hasMoreDesign, 'Design', designList)}
      </div>
    </div>
  );
};

export default DesignList;
